import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

const IntroductionToTheCourse = ({
  curriculumDataList,
  courseDetail,
  courseObject,
}) => {
  const [showObjectives, setShowObjectives] = useState(false);
  const [showIntroCourse, setShowIntroCourse] = useState(true);
  const [curriculumListData, setCurriculumListData] = useState([]);
  const [unitId, setUnitId] = useState(0);

  const [searchParams] = useSearchParams();

  useEffect(() => {
    let allData = [];

    setUnitId(curriculumDataList?.id);

    curriculumDataList?.curricula?.map((item) => {
      allData.push(...item.articles, ...item.assignments, ...item.videos);
    });
    allData.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

    setCurriculumListData(allData);
  }, [curriculumDataList]);
  const typeMapping = {
    "video/mp4": "Video",
    multiple_choice: "Multiple Choice",
    short_answer: "Short Answer",
    comprehensive: "Comprehensive",
  };
  return (
    <>
      <div className="card-default-style px-10 px-sm-20 px-md-30 px-lg-40 py-10 py-sm-15 py-md-25">
        <div className="intro-course">
          <div className="d-flex justify-content-between align-items-center">
            <h2 className="ah-heading-05 fw-bold black-800">
              Introduction to the Course
            </h2>
            <span
              className="cursor-pointer"
              onClick={() => setShowIntroCourse(!showIntroCourse)}
            >
              {showIntroCourse ? (
                <svg
                  width="15"
                  height="10"
                  viewBox="0 0 15 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.59686 3.46795L12.8598 8.73093C12.9649 8.84234 13.0917 8.93111 13.2323 8.99178C13.373 9.05245 13.5245 9.08374 13.6777 9.08374C13.8309 9.08374 13.9824 9.05245 14.1231 8.99178C14.2637 8.93111 14.3905 8.84234 14.4956 8.73093C14.6083 8.62495 14.6979 8.49686 14.7588 8.35466C14.8197 8.21247 14.8506 8.05924 14.8496 7.90455C14.8486 7.74987 14.8157 7.59705 14.7529 7.45567C14.6901 7.31429 14.5988 7.18738 14.4848 7.08288L8.39932 0.997414C8.18128 0.790186 7.89151 0.675378 7.5907 0.677045C7.44299 0.672141 7.29588 0.698101 7.15877 0.753263C7.02166 0.808427 6.89756 0.891581 6.7944 0.997414L0.708935 7.08288C0.596152 7.18567 0.506722 7.31146 0.446674 7.45174C0.386627 7.59203 0.357358 7.74356 0.360842 7.89612C0.374744 8.20113 0.507418 8.48859 0.730498 8.69705C0.835604 8.80846 0.962365 8.89722 1.103 8.95789C1.24364 9.01856 1.3952 9.04986 1.54836 9.04986C1.70153 9.04986 1.85308 9.01856 1.99372 8.95789C2.13436 8.89722 2.26112 8.80846 2.36623 8.69705L7.59686 3.46949V3.46795Z"
                    fill="#1F1F1F"
                  />
                </svg>
              ) : (
                <svg
                  width="15"
                  height="10"
                  viewBox="0 0 15 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.59686 6.53205L12.8598 1.26907C12.9649 1.15766 13.0917 1.06889 13.2323 1.00822C13.373 0.947548 13.5245 0.916258 13.6777 0.916258C13.8309 0.916258 13.9824 0.947548 14.1231 1.00822C14.2637 1.06889 14.3905 1.15766 14.4956 1.26907C14.6083 1.37505 14.6979 1.50314 14.7588 1.64534C14.8197 1.78753 14.8506 1.94076 14.8496 2.09545C14.8486 2.25013 14.8157 2.40295 14.7529 2.54433C14.6901 2.68571 14.5988 2.81262 14.4848 2.91712L8.39932 9.00259C8.18128 9.20981 7.89151 9.32462 7.5907 9.32296C7.44299 9.32786 7.29588 9.3019 7.15877 9.24674C7.02166 9.19157 6.89756 9.10842 6.7944 9.00259L0.708935 2.91712C0.596152 2.81433 0.506722 2.68854 0.446674 2.54826C0.386627 2.40797 0.357358 2.25644 0.360842 2.10388C0.374744 1.79887 0.507418 1.51141 0.730498 1.30295C0.835604 1.19154 0.962365 1.10278 1.103 1.04211C1.24364 0.981444 1.3952 0.950144 1.54836 0.950144C1.70153 0.950144 1.85308 0.981444 1.99372 1.04211C2.13436 1.10278 2.26112 1.19154 2.36623 1.30295L7.59686 6.53051V6.53205Z"
                    fill="#1F1F1F"
                  />
                </svg>
              )}
            </span>
          </div>
          <div
            className={`intro-course-inner pe-5 mt-21 ${
              showIntroCourse ? "" : "d-none"
            }`}
          >
            {/* <div className="ah-text-sm fw-normal text-gray-600">
              <svg
                width="13"
                height="10"
                viewBox="0 0 13 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.26848 7.52267L8.80208 5.27227C8.84448 5.24547 8.87913 5.20803 8.90257 5.16368C8.92601 5.11933 8.93743 5.06961 8.93568 5.01947C8.93793 4.97002 8.92669 4.92089 8.90315 4.87735C8.87962 4.8338 8.84468 4.79748 8.80208 4.77227L5.26848 2.52347C5.22419 2.49104 5.17127 2.47251 5.11642 2.47023C5.06158 2.46795 5.0073 2.48203 4.96048 2.51067C4.91149 2.53458 4.87047 2.57215 4.84236 2.61885C4.81425 2.66555 4.80026 2.71939 4.80208 2.77387V7.26827C4.80208 7.39387 4.85488 7.48427 4.96048 7.54027C5.06608 7.59627 5.16848 7.58987 5.26848 7.52347V7.52267ZM1.20208 9.82267C0.871677 9.82267 0.589277 9.70507 0.354077 9.47067C0.240634 9.36083 0.15088 9.22893 0.0903422 9.08309C0.0298048 8.93725 -0.000233566 8.78056 0.00207698 8.62267V1.41707C0.00207698 1.08667 0.119677 0.805072 0.354077 0.572272C0.464236 0.459415 0.596252 0.370206 0.742055 0.310096C0.887859 0.249987 1.04439 0.220239 1.20208 0.222672H11.6021C11.9325 0.222672 12.2149 0.340272 12.4501 0.574672C12.6845 0.810672 12.8021 1.09307 12.8021 1.42267V8.62747C12.8021 8.95787 12.6845 9.23947 12.4501 9.47227C12.34 9.58527 12.208 9.67463 12.0622 9.73488C11.9164 9.79513 11.7598 9.825 11.6021 9.82267H1.20208ZM1.20208 8.62267H11.6021V1.42267H1.20208V8.62267Z"
                  fill="#1F1F1F"
                />
              </svg>
              <span className="fw-semibold ms-4">21h 10m </span>
              of videos left
            </div> */}
            <hr className="my-19" />
            <p className="text-base fw-normal text-gray-600 mb-21">
              {courseDetail?.description}
            </p>
            <h4 className="text-base fw-bold black-800">Learning Objectives</h4>
            <hr className="my-21" />
            <ul
              className={`text-base fw-normal text-gray-600 ${
                showObjectives ? "" : "d-none"
              }`}
            >
              {courseObject &&
                courseObject.map((item, index) => (
                  <li className="mb-10 mb-sm-21" key={index}>
                    {item.objective}
                  </li>
                ))}
            </ul>
            <span
              className="ah-text-base fw-semibold text-green cursor-pointer"
              onClick={() => setShowObjectives(!showObjectives)}
            >
              <span className="me-9">
                {showObjectives ? (
                  <svg
                    width="15"
                    height="10"
                    viewBox="0 0 15 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.59686 3.46795L12.8598 8.73093C12.9649 8.84234 13.0917 8.93111 13.2323 8.99178C13.373 9.05245 13.5245 9.08374 13.6777 9.08374C13.8309 9.08374 13.9824 9.05245 14.1231 8.99178C14.2637 8.93111 14.3905 8.84234 14.4956 8.73093C14.6083 8.62495 14.6979 8.49686 14.7588 8.35466C14.8197 8.21247 14.8506 8.05924 14.8496 7.90455C14.8486 7.74987 14.8157 7.59705 14.7529 7.45567C14.6901 7.31429 14.5988 7.18738 14.4848 7.08288L8.39932 0.997414C8.18128 0.790186 7.89151 0.675378 7.5907 0.677045C7.44299 0.672141 7.29588 0.698101 7.15877 0.753263C7.02166 0.808427 6.89756 0.891581 6.7944 0.997414L0.708935 7.08288C0.596152 7.18567 0.506722 7.31146 0.446674 7.45174C0.386627 7.59203 0.357358 7.74356 0.360842 7.89612C0.374744 8.20113 0.507418 8.48859 0.730498 8.69705C0.835604 8.80846 0.962365 8.89722 1.103 8.95789C1.24364 9.01856 1.3952 9.04986 1.54836 9.04986C1.70153 9.04986 1.85308 9.01856 1.99372 8.95789C2.13436 8.89722 2.26112 8.80846 2.36623 8.69705L7.59686 3.46949V3.46795Z"
                      fill="#82bd00"
                    />
                  </svg>
                ) : (
                  <svg
                    width="15"
                    height="10"
                    viewBox="0 0 15 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.59686 6.53205L12.8598 1.26907C12.9649 1.15766 13.0917 1.06889 13.2323 1.00822C13.373 0.947548 13.5245 0.916258 13.6777 0.916258C13.8309 0.916258 13.9824 0.947548 14.1231 1.00822C14.2637 1.06889 14.3905 1.15766 14.4956 1.26907C14.6083 1.37505 14.6979 1.50314 14.7588 1.64534C14.8197 1.78753 14.8506 1.94076 14.8496 2.09545C14.8486 2.25013 14.8157 2.40295 14.7529 2.54433C14.6901 2.68571 14.5988 2.81262 14.4848 2.91712L8.39932 9.00259C8.18128 9.20981 7.89151 9.32462 7.5907 9.32296C7.44299 9.32786 7.29588 9.3019 7.15877 9.24674C7.02166 9.19157 6.89756 9.10842 6.7944 9.00259L0.708935 2.91712C0.596152 2.81433 0.506722 2.68854 0.446674 2.54826C0.386627 2.40797 0.357358 2.25644 0.360842 2.10388C0.374744 1.79887 0.507418 1.51141 0.730498 1.30295C0.835604 1.19154 0.962365 1.10278 1.103 1.04211C1.24364 0.981444 1.3952 0.950144 1.54836 0.950144C1.70153 0.950144 1.85308 0.981444 1.99372 1.04211C2.13436 1.10278 2.26112 1.19154 2.36623 1.30295L7.59686 6.53051V6.53205Z"
                      fill="#82bd00"
                    />
                  </svg>
                )}
              </span>
              {showObjectives
                ? "Hide Learning Objectives"
                : "Show Learning Objectives"}
            </span>
            <hr className="my-10 my-sm-24" />
            <div className="course-list-container container py-4">
              <ul className="list-unstyled course-list">
                {curriculumListData?.map((item, index) => (
                  <li
                    key={index}
                    className={`d-flex align-items-start justify-content-between mb-3 course-item py-5 py-sm-10 flex-wrap gap-2 ${
                      item.completed ? "completed" : ""
                    }`}
                  >
                    <div className="d-flex">
                      {window.location.pathname !== "/course-view" && (
                        <div className="icon me-14 d-flex align-items-start justify-content-center">
                          <>
                            {item.completed ? (
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M8.72419 11.0728L7.22419 9.59677C7.14411 9.51099 7.04734 9.44248 6.93984 9.39543C6.83233 9.34838 6.71634 9.32379 6.59899 9.32317C6.48156 9.32395 6.36552 9.34873 6.258 9.39598C6.15049 9.44324 6.05377 9.51197 5.97379 9.59797C5.88699 9.67986 5.81784 9.77862 5.77057 9.88819C5.7233 9.99776 5.69892 10.1158 5.69892 10.2352C5.69892 10.3545 5.7233 10.4726 5.77057 10.5821C5.81784 10.6917 5.88699 10.7905 5.97379 10.8724L8.09779 12.9976C8.28139 13.1812 8.49019 13.2736 8.72299 13.2736C8.84052 13.2726 8.95661 13.2477 9.06413 13.2002C9.17165 13.1527 9.26832 13.0838 9.34819 12.9976L14.0234 8.32237C14.1102 8.24048 14.1794 8.14172 14.2266 8.03215C14.2739 7.92258 14.2983 7.8045 14.2983 7.68517C14.2983 7.56584 14.2739 7.44776 14.2266 7.33819C14.1794 7.22862 14.1102 7.12986 14.0234 7.04797C13.9437 6.9619 13.8472 6.89303 13.7399 6.84557C13.6326 6.79811 13.5167 6.77306 13.3994 6.77197C13.2819 6.7729 13.1658 6.79787 13.0583 6.84533C12.9507 6.8928 12.8541 6.96176 12.7742 7.04797L8.72419 11.0728ZM9.99859 19.6228C8.71876 19.6302 7.45102 19.3749 6.27379 18.8728C5.13006 18.3881 4.09033 17.6878 3.21139 16.81C2.33359 15.9311 1.63324 14.8913 1.14859 13.7476C0.646469 12.5703 0.391207 11.3026 0.398593 10.0228C0.398593 8.68957 0.648193 7.44277 1.14859 6.28477C2.13103 3.98211 3.96763 2.1498 6.27259 1.17277C7.4502 0.670485 8.71836 0.415219 9.99859 0.42277C11.3318 0.42277 12.5786 0.67237 13.7366 1.17277C16.0348 2.15561 17.8658 3.98653 18.8486 6.28477C19.349 7.44397 19.5986 8.69077 19.5986 10.0228C19.606 11.3026 19.3507 12.5703 18.8486 13.7476C17.8719 16.0531 16.0395 17.8902 13.7366 18.8728C12.5555 19.3774 11.2829 19.6328 9.99859 19.6228Z"
                                  fill="#F05203"
                                />
                              </svg>
                            ) : (
                              <div className="circle"></div>
                            )}
                          </>
                        </div>
                      )}
                      <div className="content">
                        <div className="ah-text-base black-800 fw-semibold">
                          {item.title}
                        </div>
                        <div className="ah-text-md fw-normal text-gray-600">
                          {item?.type
                            ? typeMapping[item.type] || item.type
                            : item?.content
                            ? "Article"
                            : ""}
                        </div>
                      </div>
                    </div>
                    {window.location.pathname === "/course-view" ? (
                      <Link
                        to={`/student-course-view-detail?id=${searchParams.get(
                          "id"
                        )}&unit=${unitId}&curriculum-id=${item.id}`}
                        className="btn btn-soft-primary no-shadow py-5 px-20"
                      >
                        View
                      </Link>
                    ) : (
                      <>
                        {item.active ? (
                          <Link
                            to={`/student-course-videos?id=${searchParams.get(
                              "id"
                            )}&unit=${unitId}&curriculum-id=${item.id}`}
                            className="btn btn-soft-primary no-shadow py-5 px-20"
                          >
                            Resume
                          </Link>
                        ) : !item.active && item.completed ? (
                          <Link
                            to={`/student-course-videos?id=${searchParams.get(
                              "id"
                            )}&unit=${unitId}&curriculum-id=${item.id}`}
                            className="btn btn-soft-primary no-shadow py-5 px-20"
                          >
                            Complete
                          </Link>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                    {/* {item.completed ? (
                      <Link
                        to={"/student-course-videos"}
                        className="btn btn-soft-primary no-shadow py-5 px-20"
                      >
                        Resume
                      </Link>
                    ) : (
                      ""
                    )} */}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IntroductionToTheCourse;
